import React from 'react';
import Header from '../components/header/Header';
import Slider from '../components/slider/Slider';
import { sliderData } from './../helpers/SliderData';
import ServicesSlide from '../components/servicesSlide/ServicesSlide'
import PriceCard from '../components/priceCard/PriceCard'
import {prices} from '../helpers/priceList'
import GallerySlider from '../components/gallerySlider/GallerySlider'
import ActionData from '../components/actionData/ActionData'

const Gallery = () => {
  return (
    <>
      <Header 
              title="Discover My"
              subtitle="Gallery"
              subtitle_2="I Capture"
              text="Hi! For me, photography is not just pictures but stories told through frames. Every moment is unique, and my goal is to capture it in a way that allows you to return to it time and again. Through the lens, I strive to convey genuine emotions and create works that will be treasured for years to come."
              typedTextStrings={["Moments", "Feelings", "Memories Fulfilled with Love"]}
              link="#gallerySlider"
              button_text="Show my work"
            />
          
      <main>
        <section className="gallerySlider section" id='gallerySlider'>
          
          <GallerySlider />
          
        </section>

        <section className="slider section">
          <div className="container">
          <ActionData />
            <div className="content__grid">
                
                <p>Cherish the moments with your loved ones and create memories that will warm your heart for years to come. <br/>
                An atmospheric Christmas photo just for you - whether it's a single portrait or a joyful family moment in the Christmas spirit. </p>
            </div>
            <div>
              <Slider data={sliderData}/>
            </div>
              
          </div>
        </section>

        <ServicesSlide />

        <section className="price section" id="price">
          <div className="container">
            <h2 className="title-2">My <span className='accent'>prices</span></h2>

            <div className="price__cards">
              <div className="prices__cards-inner">
                {prices.map((price, index) => (
                  <PriceCard 
                    key={index}
                    img={price.img}
                    title={price.title}
                    price={price.price}
                    description_1={price.description_1}
                    description_2={price.description_2}
                    description_3={price.description_3}
                    duration={price.duration}
                />
              ))}
              </div>
              <div className="price__cards-descr">
                <p>* All prices include VAT 25.5%</p>
                <p>* Additional images and paintings at a separate price, individually or in larger image packages. <br/>Contact us to calculate the price of your photo.</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      
    </>
  )
}

export default Gallery
